<template>
  <div>
    <span>
      <!-- <vs-dropdown>
        <a class="a-icon" href="#" style="color: #ddd;">
          {{ params.value.name }}
          <vs-icon class="" icon="expand_more"> </vs-icon>
        </a>
        <vs-dropdown-menu @click="openDropdown">
          <vs-dropdown-item
            v-for="(item, index) in choice"
            :key="index"
            @click="changeStatus(item.value)"
          >
            {{ item.name }}
          </vs-dropdown-item>
        </vs-dropdown-menu> -->
      <!-- <vs-dropdown-menu v-if="nowPage == 'User Management'">
          <vs-dropdown-item>
            Publish
          </vs-dropdown-item>
          <vs-dropdown-item>
            Banned
          </vs-dropdown-item>
        </vs-dropdown-menu> -->
      <!-- </vs-dropdown> -->
      <select
        v-if="this.$route.path === '/manageadmin'"
        @change="changeStatus($event)"
        v-model="selected"
        :class="!roleList.includes(+selected) ? 'no-role' : ''"
        :disabled="!permission.role_edit"
      >
        <option
          v-for="(item, index) in choice"
          :key="index"
          :value="item.role_id"
          >{{ item.name }}</option
        >
      </select>
      <div
        style="width: 170px"
        v-else-if="
          this.$route.path === '/invoice' ||
            this.$route.path.includes('receipt')
        "
      >
        <vs-dropdown
          class="w-full"
          :disabled="!params.data.choice || params.data.choice.length === 0"
          vs-trigger-click
        >
          <div
            class="w-full flex justify-between items-center pl-1 like-select"
            :style="{ color: activeColor, backgroundColor: backgroundColor }"
          >
            <p>{{ params.data.dropdown }}</p>
            <vs-icon icon="expand_more"> </vs-icon>
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item>
              <div class="w-max">
                <div
                  v-for="(datum, index) in params.data.choice"
                  :key="index"
                  @click="changeStatus(datum.name)"
                  class="flex my-2"
                >
                  <img
                    src="./../../../../assets/mail.svg"
                    v-if="datum.name === 'ส่งอีเมลแล้ว'"
                    class="pr-2"
                  />
                  <img
                    src="./../../../../assets/billing.svg"
                    v-if="datum.name === 'วางบิล'"
                    class="pr-2"
                  />
                  <img
                    src="./../../../../assets/file-earmark.svg"
                    v-if="datum.name === 'ออกใบเสร็จรับเงิน'"
                    class="pr-2"
                  />
                  <img
                    src="./../../../../assets/Group.svg"
                    v-if="datum.name === 'แบ่งรับชำระ'"
                    class="pr-2"
                  />
                  <img
                    src="./../../../../assets/material-cancel.svg"
                    v-if="datum.name === 'ยกเลิก'"
                    class="pr-2"
                  />
                  <img
                    src="./../../../../assets/Exclusion.svg"
                    v-if="datum.name === 'รีเซ็ต'"
                    class="pr-2"
                  />
                  <p>
                    <nobr>{{ datum.name }}</nobr>
                  </p>
                </div>
              </div>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <select
        v-else
        @change="changeStatus($event)"
        v-model="selected"
        :disabled="this.$route.path === '/receipt'"
      >
        <option
          v-for="(item, index) in choice"
          :key="index"
          :value="item.name"
          >{{ item.name }}</option
        >
      </select>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import baseUrl from "../../../../util/backend.js";
export default {
  data() {
    return {
      choice: null,
      selected: null,
      roleList: [],
    };
  },
  mounted() {
    // console.log("params", this.params.data.choice);
    this.choice = this.params.data.choice;
    if (this.$route.path === "/manageadmin") {
      for (const c of this.params.data.choice) {
        this.roleList.push(c.role_id);
      }
    }
    this.selected = this.params.data.dropdown;
  },
  methods: {
    openDropdown() {
      console.log("params", this.params.data.choice);
    },
    async changeStatus(data) {
      // console.log(this.params.data);
      // console.log(`${this.params.data.dropdown}เปลี่ยนstatusเป็น${data}`);
      // console.log(this.params.data.dropdown);
      // if (this.$route.path === "/invoice") {
      //   const res = await axios.post(
      //     `${baseUrl}/invoice/changestatus?invoice_id=${this.params.data.more[0].value}`,
      //     {
      //       status: data.target.value,
      //     }
      //   );
      //   console.log(res);
      //   console.log(
      //     `${this.params.data.dropdown}เปลี่ยนstatusเป็น${data.target.value}`
      //   );
      //   // console.log(this.params.data.more[0].value);
      // }
      if (this.$route.path === "/invoice") {
        if (data === "วางบิล") {
          const res = await axios.post(
            `${baseUrl}/invoice/changestatus?invoice_id=${this.params.data.more[0].value}`,
            {
              status: "วางบิลแล้ว",
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
        }
        if (data === "ออกใบเสร็จรับเงิน" || data === "แบ่งรับชำระ") {
          // console.log(this.params.data);
          console.log("this.params.data", this.params.data);
          this.$store.dispatch("create/setSelectedInvoice", [this.params.data]);
          this.$router.push("/createreceipt");
        }
        if (data === "ยกเลิก") {
          const res = await axios.post(
            `${baseUrl}/invoice/changestatus?invoice_id=${this.params.data.more[0].value}`,
            {
              status: "ยกเลิก",
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
        }
        if (data === "รีเซ็ต") {
          const res = await axios.post(
            `${baseUrl}/invoice/changestatus?invoice_id=${this.params.data.more[0].value}`,
            {
              status: "รอดำเนินการ",
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
        }
        this.$root.$emit("update-table");
      }
      if (this.$route.path === "/receipt") {
        if (data === "ส่งอีเมลแล้ว") {
          const res = await axios.post(
            `${baseUrl}/receipt/changestatus?receipt_id=${this.params.data.more[0].value}`,
            {
              status: "ส่งอีเมลแล้ว",
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
        }
        if (data === "ยกเลิก") {
          const res = await axios.post(
            `${baseUrl}/receipt/changestatus?receipt_id=${this.params.data.more[0].value}`,
            {
              status: "ยกเลิก",
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
        }
        if (data === "รีเซ็ต") {
          const res = await axios.post(
            `${baseUrl}/receipt/changestatus?receipt_id=${this.params.data.more[0].value}`,
            {
              status: "ออกใบเสร็จรับเงินแล้ว",
            },
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
        }
        this.$root.$emit("update-table");
      }
      if (this.$route.path === "/manageadmin") {
        if (this.roleList.includes(+data.target.value)) {
          try {
            const res = await axios.post(
              `${baseUrl}/profile/edit?user_id=${this.params.data.user_id}`,
              {
                role_id: data.target.value,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getToken,
                },
              }
            );
            console.log(res);
            // console.log(this.params.data.user_id);
          } catch (err) {
            alert(err);
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      nowPage: "getNowPage",
    }),
    permission() {
      return this.$store.getters.getPermission;
    },
    activeColor() {
      if (this.$route.path === "/invoice") {
        if (this.params.data.dropdown !== "รอดำเนินการ") {
          return "#434f5b";
        }
      }
      if (this.$route.path === "/receipt") {
        if (this.params.data.dropdown !== "ออกใบเสร็จรับเงินแล้ว") {
          return "#434f5b";
        }
      }
    },
    backgroundColor() {
      if (this.$route.path === "/invoice") {
        if (this.params.data.dropdown === "วางบิลแล้ว") {
          return "#fdfadb";
        }
        if (this.params.data.dropdown === "ออกใบเสร็จรับเงินแล้ว") {
          return "#d9f2de";
        }
        if (this.params.data.dropdown === "แบ่งรับชำระ") {
          return "#ffdfbe";
        }
        if (this.params.data.dropdown === "ยกเลิก") {
          return "#ffdad7";
        }
      }
      if (this.$route.path === "/receipt") {
        if (this.params.data.dropdown === "ส่งอีเมลแล้ว") {
          return "#d9f2de";
        }
        if (this.params.data.dropdown === "ยกเลิก") {
          return "#ffdad7";
        }
      }
    },
  },
};
</script>

<style scoped>
select {
  font-size: 17px;
  color: #dddddd;
  background-color: #4e5363;
  border-radius: 5px;
  border: solid 0.5px #8d9498;
}

select option {
  background-color: #4e5363;
}

/* .no-role {
  background-color: #ff4a3d;
} */

.like-select {
  font-size: 17px;
  border-radius: 5px;
  border: solid 0.5px #8d9498;
}
</style>
